import React from 'react';

function VolumeStats({
  volData = null,
  volPer = 'all',
  onPeriodChange,
  className = ''
}) {
  const renderStats = () => {
    if (!volData) return null;
    const getStats = () => {
      switch (volPer) {
        case 'day':
          return volData.day?.[0]?.[0] || { sales: '0', vol: '0', floorprice: '0' };
        case 'week':
          return volData.week?.[0]?.[0] || { sales: '0', vol: '0', floorprice: '0' };
        case 'month':
          return volData.month?.[0]?.[0] || { sales: '0', vol: '0', floorprice: '0' };
        case 'all':
        default:
          return volData.alltime?.[0]?.[0] || { sales: '0', vol: '0', floorprice: '0' };
      }
    };
    const stats = getStats();
    const label = {
      day: '24h',
      week: 'Week',
      month: 'Month',
      all: 'All',
    }[volPer] || 'All';
    return (
      <div className="volume-stats-row text-secondary small" style={{ lineHeight: 1.25 }}>
        <span className="text-white fw-medium">{label}</span>
        <span> · Sales {stats?.sales ?? '0'}</span>
        <span> · Vol {stats?.vol ?? '0'}</span>
        <span> · Floor {stats?.floorprice ?? '0'}</span>
      </div>
    );
  };

  const periods = [
    { key: 'all', label: 'All' },
    { key: 'month', label: 'Month' },
    { key: 'week', label: 'Week' },
    { key: 'day', label: '24h' },
  ];

  return (
    <div className={`volume-stats ${className}`}>
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <span className="text-secondary small fw-semibold" style={{ fontSize: '0.78rem' }}>Trading Volume</span>
        <div className="d-flex gap-2">
          {periods.map((p) => (
            <button
              key={p.key}
              onClick={() => onPeriodChange && onPeriodChange(p.key)}
              className="volume-tab"
              aria-pressed={volPer === p.key}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
      {volData && renderStats()}
    </div>
  );
}

export default VolumeStats;
